import loadable from '@loadable/component';
import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { hooks } from '../../../utils';

import { DynamicContainer } from '../Layout';
import { ContainerType } from '../Layout/constants';
import Text, { TextTypes } from '../Text';

import { ColorLine, colorLineKeyframes } from '../ColorLine';

import FooterNav from './FooterNav';
import SocialNetworks from '../SocialNetworks';
import CopyRight from './CopyRight';
import LazyLoadContainer from '../LazyLoad';

const Awards = loadable(() => import('./Awards'));

const { useStars } = hooks;

const Footer = ({ rules, styles, lazyLoaded, reference }) => {
    const { colorLines } = useStars();

    return (
        <DynamicContainer ref={reference} as={ContainerType.FOOTER} extend={rules.extendContainer} columns={12} dark>
            <LazyLoadContainer unmountIfInvisible lazyLoaded={lazyLoaded}>
                <DynamicContainer isFluid extend={rules.extendContainerInner} type={ContainerType.GRID} columns={12}>
                    <div className={styles.imagesContainer}>
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={styles.imgLeft}
                        >
                            <path d="M32 15H17V0H15V15H0V17H15V32H17V17H32V15Z" opacity={0.4} fill="white" />
                        </svg>

                        <Text extend={rules.extendText} type={TextTypes.SECTION}>
                            <FormattedMessage id="footer.section.heading" />
                        </Text>

                        <svg
                            className={styles.imgRight}
                            width="211"
                            height="28"
                            viewBox="0 0 211 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            opacity={0.4}
                        >
                            <path d="M190.51 27.19L164.32 1H0" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
                            <path d="M183.92 1L210.11 27.19" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
                        </svg>
                    </div>

                    <FooterNav />

                    <Awards />

                    <div className={styles.imagesBottomContainer}>
                        <svg
                            width="177"
                            height="26"
                            viewBox="0 0 177 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={styles.imgBottomLeft}
                        >
                            <path
                                opacity="0.4"
                                d="M176.5 24.5446H68.1556L44.7156 1H0"
                                stroke="white"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                            />
                        </svg>

                        <svg
                            width="145"
                            height="102"
                            viewBox="0 0 145 102"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className={styles.imgBottomRight}
                        >
                            <path
                                opacity="0.4"
                                d="M0.5 101L106.5 101L143.5 58.2139L143.5 0.595356"
                                stroke="white"
                                strokeWidth="2"
                            />
                        </svg>
                    </div>

                    <div className={styles.copySocialWrapper}>
                        <CopyRight />

                        <SocialNetworks />
                    </div>

                    <ColorLine keyframe={colorLineKeyframes.leftTranslate} {...colorLines[1]} />
                    <ColorLine keyframe={colorLineKeyframes.rightTranslate} {...colorLines[2]} />
                    <ColorLine keyframe={colorLineKeyframes.rightTranslate} {...colorLines[3]} />
                </DynamicContainer>
            </LazyLoadContainer>
        </DynamicContainer>
    );
};

Footer.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    lazyLoaded: PropTypes.bool,
    reference: PropTypes.shape(),
};

Footer.defaultProps = {
    lazyLoaded: false,
    reference: null,
};

export default Footer;
